export default "__VITE_ASSET__3ec75777__"